// export function convertMillisecondsToSeconds(ms:number):string {
//   // floor to remove fractional milliseconds
//   ms = Math.floor(ms);

//   const seconds = Math.floor(ms / 1000);
//   let milliseconds:any = Math.floor((ms % 1000) / 10); // convert 3-digit ms → 2 digits

//   // always keep 2 digits
//   milliseconds = milliseconds.toString().padStart(2, "0");

//   return `${seconds}:${milliseconds}`;
// }

export function convertMillisecondsToSeconds(ms: number): string {
  return Math.floor(ms / 1000).toString();
}
